var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"fill-height":"","fluid":"","justify-center":"","align-center":""}},[_c('v-card',{staticClass:"pa-3 mx-auto",attrs:{"width":"500","raised":""}},[_c('div',{staticClass:"pa-3"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }